import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=9f4213f8&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=9f4213f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4213f8",
  null
  
)

export default component.exports